<template>
  <div class="ai-platform-page hero-style-home">
    <div class="ai-hero-banner">
      <img
        src="@/assets/jiejue/custom/sase-hero-banner.svg"
        alt=""
        srcset=""
        style="width: 100%"
        @load="loaded = true"
        :class="{ show: loaded }"
        class="top_img"
      />
      <div class="ai-hero-title">SASE安全解决方案</div>
    </div>

    <nav class="product-tabs-bar">
      <a
        class="product-tab"
        :class="{ active: activeTab === 'background' }"
        href="#background"
        @click.prevent="scrollTo('background')"
        >需求背景</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'challenges' }"
        href="#challenges"
        @click.prevent="scrollTo('challenges')"
        >业务挑战</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'scenarios' }"
        href="#scenarios"
        @click.prevent="scrollTo('scenarios')"
        >场景应用</a
      >
      <a
        v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM"
        class="product-tab"
        :class="{ active: activeTab === 'architecture' }"
        href="#architecture"
        @click.prevent="scrollTo('architecture')"
        >部署示意图</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'advantages' }"
        href="#advantages"
        @click.prevent="scrollTo('advantages')"
        >方案优势</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'cases' }"
        href="#cases"
        @click.prevent="scrollTo('cases')"
        >典型案例</a
      >
    </nav>

    <div class="product-body">
    <section
      id="background"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': backgroundVisible }"
    >
      <div class="section-title">需求背景</div>
      <div class="section-content">
        <div class="background-card">
          <p class="case-text case-text-full">
            SASE 安全解决方案是基于云资源池与 SASE 盒子构建一体化安全运营体系，实现对分布式办公终端、分支节点、云端业务的全域安全覆盖。依托统一的云端管理平台，实现安全策略的集中编排、威胁的实时监测与自动化响应，精准识别并处置恶意攻击、数据泄露等风险，还能适配混合合规与数据安全法规要求，大幅简化复杂网络环境下的安全运维流程，为企业数字化转型提供灵活、高效且可弹性扩展的全链路安全保障。
          </p>
        </div>
      </div>
    </section>

    <section
      id="challenges"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': challengesVisible }"
    >
      <div class="section-title">业务挑战</div>
      <div class="section-content">
      <div class="grid-2">
        <div class="card">
          <img
            class="card-icon"
            src="@/assets/jiejue/sase/1.svg"
            alt="icon"
          />
          <div class="card-text">
            <div class="card-title">高成本低效率</div>
            <div class="card-desc">
              网络安全建设成本高、维护成本高，3-5年后，安全软硬件就需要升级换代；需要专人维护，购买的80%以上产品未产生真正价值。
            </div>
          </div>
        </div>
        <div class="card">
          <img
            class="card-icon"
            src="@/assets/jiejue/sase/2.svg"
            alt="icon"
          />
          <div class="card-text">
            <div class="card-title">安全设备分散</div>
            <div class="card-desc">
              设备的配置普遍不合理，很多功能没有真正发挥作用，无法捕获入侵攻击事件或者产生大量误报，不能让安全设备之间形成有效的协同联动和情报共享。
            </div>
          </div>
        </div>
        <div class="card">
          <img
            class="card-icon"
            src="@/assets/jiejue/sase/3.svg"
            alt="icon"
          />
          <div class="card-text">
            <div class="card-title">云边协同挑战</div>
            <div class="card-desc">
              传统方案无法实现有效的云边协调，并且很多客户业务系统信息化再本地，无法实现本地业务流量引流到云端，通过云端的安全能力统一防护。
            </div>
          </div>
        </div>
        <div class="card">
          <img
            class="card-icon"
            src="@/assets/jiejue/sase/4.svg"
            alt="icon"
          />
          <div class="card-text">
            <div class="card-title">日志量大误报高</div>
            <div class="card-desc">
              对于所有设备的海量日志无法进行有效精准分析，并且很多告警都是存在误报问题，运维人员压力极大。
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>

    <section
      id="scenarios"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': scenariosVisible }"
    >
      <div class="section-title">场景应用</div>
      <div class="section-content">
      <div class="scenarios">
        <div class="scenario-text">
          <div class="scenario-item">
            <div class="item-title">总分机构跨地域安全互联场景</div>
            <div class="item-desc">
              针对集团总部与异地分支、子公司的互联需求，SASE替代传统专线与分散安全设备，通过云端安全资源池+SASE盒子构建虚拟专用网络。分支机构部署SASE盒子，同时集成防火墙、IPS、VPN等安全能力，抵御跨域传输中的网络攻击与数据泄露风险。
            </div>
          </div>
          <div class="scenario-item highlight">
            <div class="item-title">分支轻量化快速部署与弹性扩展场景</div>
            <div class="item-desc">
              面对总分机构分支数量多、分布散（含临时项目组、门店、偏远办事处）的特点，SASE采用云端安全资源
              池+SASE盒子模式，针对移动办公分支无需部署本地安全网关，仅通过轻量客户端接入方式，本地可按需
              扩展安全能力。
            </div>
          </div>
        </div>
        <img
          src="@/assets/jiejue/sase/right.svg"
          alt=""
          style="width: 50%; border-radius: 4px"
          class="mobile-hidden-img"
        />
      </div>
      </div>
    </section>

    <section
      v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM"
      id="architecture"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': architectureVisible }"
    >
      <div class="section-title">部署示意图</div>
      <div class="section-content">
      <img
        src="@/assets/solutions/deploy/sase.svg"
        alt="部署示意图"
        class="architecture-image"
      />
      </div>
    </section>

    <section
      id="advantages"
      class="product-section section-row advantages ai-platform-block"
      :class="{ 'animate-in': advantagesVisible }"
    >
      <div class="section-title">方案优势</div>
      <div class="section-content">
      <div class="grid-4">
        <div class="adv-card">
          <!-- <div class="adv-badge">1</div> -->
          <img src="@/assets/jiejue/1.svg" alt="" class="adv-badge" />
          <div class="adv-title">架构协同保障</div>
          <div class="adv-desc">
            “云端资源池+本地SASE盒子”分布式协同，云端提供弹性算力与全局管控，本地集成防火墙/IPS/VPN等能力，既加密跨域互联，又实时防护本地风险，破解云端延迟、本地防护弱痛点。​
          </div>
        </div>
        <div class="adv-card">
          <!-- <div class="adv-badge">1</div> -->
          <img src="@/assets/jiejue/1.svg" alt="" class="adv-badge" />
          <div class="adv-title">部署灵活适配</div>
          <div class="adv-desc">
            分支部署标准化SASE盒子，开箱即接入，无需复杂硬件与专业驻场，快速上线；适配不同规模分支，可按需新增或扩容，弹性响应业务变化。
          </div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/2.svg" alt="" class="adv-badge" />
          <div class="adv-title">统一管控合规</div>
          <div class="adv-desc">
            云端集中管理平台实现安全策略一键下发、全域一致，解决策略碎片化问题；盒子记录行为日志并同步云端，溯源可审计，满足合规要求。​
          </div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/3.svg" alt="" class="adv-badge" />
          <div class="adv-title">降本增效平衡</div>
          <div class="adv-desc">
            替代传统高成本方案，集成化能力减少硬件与运维投入，云端按需调度避免算力浪费；本地低延迟处理+跨域优化路由，兼顾安全、成本与业务体验。
          </div>
        </div>
      </div>
      </div>
    </section>

    <section
      id="cases"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': casesVisible }"
    >
      <div class="section-title">典型案例</div>
      <div class="section-content section-content-cases">
        <div class="case-content case-content-blink">
          <div class="case-section">
            <h3 class="case-subtitle">客户背景</h3>
            <p class="case-text">
              该企业为区域型装备制造企业，采用“总部 + 2 个生产基地 + 1 个中心仓储”的布局，员工约 500 人；研发、ERP 与供应链系统部署在总部，生产基地通过专线或互联网与总部互联。日常有大量工艺工程师远程运维、移动办公，以及少量供应链伙伴临时接入需求。随着数字化与远程协作推进，企业面临多基地安全与接入管控的双重挑战。
            </p>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">业务挑战</h3>
            <ul class="case-list">
              <li>1. 多基地安全分散：总部与生产基地安全设备型号不一、策略各自为政，缺乏统一管控，运维靠人工逐点配置，效率低、易遗漏；</li>
              <li>2. 远程运维接入风险高：工艺与运维人员远程调试设备、访问总部系统，身份难精准识别，存在越权访问与数据泄露隐患；</li>
              <li>3. 供应链临时接入难管控：少量供应商/合作伙伴需临时接入内网取数或协同，传统 VPN 权限粗放，难以按需收敛与审计；</li>
              <li>4. 合规要求明确：工业数据与业务系统受等级保护要求约束，原分散方案难以形成统一防护与可溯源的合规证据链。</li>
            </ul>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">解决方案（基于自研 SASE 安全架构）</h3>
            <p class="case-text">企业引入 SASE 安全解决方案，构建“云—网—边—端”一体的安全运营体系：</p>
            <ul class="case-list">
              <li>云端：总部部署云端安全资源池，实现安全策略集中编排、威胁实时监测与自动化响应；</li>
              <li>边缘：各生产基地标准化部署 SASE 盒子，开箱即接入、无需专业驻场，本地集成防火墙、IPS、VPN 等安全能力，保障基地与总部互联安全；</li>
              <li>接入：远程运维与移动办公人员通过轻量客户端接入，按角色下发最小权限，本地按需扩展安全能力；</li>
              <li>管控：云端集中管理平台实现安全策略一键下发、全域一致，接入行为日志统一上收、溯源可审计，满足等保与工业数据防护合规要求。</li>
            </ul>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">建设成效</h3>
            <ul class="case-list">
              <li>多基地安全策略实现统一管控，安全能力上线周期缩短至 2 天以内，安全运维人力投入下降约 40%；</li>
              <li>远程运维与供应链接入身份可精准识别、权限按需收敛，越权访问与数据泄露风险显著降低；</li>
              <li>形成统一的合规审计能力，支撑企业数字化与远程协作稳妥推进，构建可持续的安全运营体系。</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    </div>

    
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { SHOW_SOLUTION_DEPLOY_DIAGRAM } from "@/data/solutionUi.js";
;

const loaded = ref(false);
const backgroundVisible = ref(false);
const challengesVisible = ref(false);
const scenariosVisible = ref(false);
const architectureVisible = ref(false);
const advantagesVisible = ref(false);
const casesVisible = ref(false);

defineOptions({
  banner: new URL("@/assets/jiejue/custom/sase-hero-banner.svg", import.meta.url).href,
});

const activeTab = ref("background");
const isScrollingProgrammatically = ref(false);
const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  activeTab.value = id;
  history.replaceState(null, "", `#${id}`);
  isScrollingProgrammatically.value = true;
  if (el.scrollIntoView) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
    const stickyOffset = 120;
    const y = el.getBoundingClientRect().top + window.scrollY - stickyOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
  setTimeout(() => {
    isScrollingProgrammatically.value = false;
  }, 1500);
};

const animationObserver = ref(null);
const navObserver = ref(null);

const updateActiveTab = () => {
  if (isScrollingProgrammatically.value) return;
  const sections = ["background", "challenges", "scenarios", "architecture", "advantages", "cases"];
  const scrollPosition = window.scrollY;
  let newActiveTab = "background";
  for (let i = 0; i < sections.length; i++) {
    const section = document.getElementById(sections[i]);
    if (section) {
      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top + window.scrollY;
      const sectionBottom = sectionTop + rect.height;
      if (scrollPosition >= sectionTop - 150 && scrollPosition < sectionBottom - 100) {
        newActiveTab = sections[i];
        break;
      }
    }
  }
  if (activeTab.value !== newActiveTab) {
    activeTab.value = newActiveTab;
    history.replaceState(null, "", `#${newActiveTab}`);
  }
};

const setupIntersectionObserver = () => {
  navObserver.value = new IntersectionObserver(
    (entries) => {
      if (isScrollingProgrammatically.value) return;
      const enteringEntries = entries.filter((e) => e.isIntersecting);
      if (enteringEntries.length === 0) return;
      let closestEntry = null;
      let minDistance = Infinity;
      enteringEntries.forEach((entry) => {
        const rect = entry.target.getBoundingClientRect();
        const distance = Math.abs(rect.top + rect.height / 2 - window.innerHeight / 2);
        if (distance < minDistance) {
          minDistance = distance;
          closestEntry = entry;
        }
      });
      if (closestEntry) {
        const sectionId = closestEntry.target.id;
        if (activeTab.value !== sectionId) {
          activeTab.value = sectionId;
          history.replaceState(null, "", `#${sectionId}`);
        }
      }
    },
    { threshold: 0.2, rootMargin: "-100px 0px -40% 0px" },
  );
  const sections = ["background", "challenges", "scenarios", "architecture", "advantages", "cases"];
  sections.forEach((sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) navObserver.value.observe(section);
  });
};

onMounted(() => {
  activeTab.value = "background";
  setTimeout(() => {
    setupIntersectionObserver();
    updateActiveTab();
  }, 300);

  animationObserver.value = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const targetId = entry.target.id;
          if (targetId === "background") backgroundVisible.value = true;
          if (targetId === "challenges") challengesVisible.value = true;
          if (targetId === "scenarios") scenariosVisible.value = true;
          if (targetId === "architecture") architectureVisible.value = true;
          if (targetId === "advantages") advantagesVisible.value = true;
          if (targetId === "cases") casesVisible.value = true;
        }
      });
    },
    { rootMargin: "-10% 0px -10% 0px", threshold: 0.1 },
  );
  document.querySelectorAll(".ai-platform-block").forEach((block) => {
    animationObserver.value.observe(block);
  });

  window.addEventListener("scroll", updateActiveTab, { passive: true });
});

onBeforeUnmount(() => {
  if (navObserver.value) navObserver.value.disconnect();
  if (animationObserver.value) animationObserver.value.disconnect();
  window.removeEventListener("scroll", updateActiveTab);
});
</script>

<style scoped>
@import '../../assets/css/solution-page.css';

.ai-hero-banner {
  position: relative;
  overflow: hidden;
}

.ai-hero-title {
  position: absolute;
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  font-size: 48px;
  color: var(--color-text);
  font-weight: 600;
  letter-spacing: 0.01em;
  text-shadow: 0 8px 24px rgba(255, 255, 255, 0.6);
  z-index: 2;
  pointer-events: none;
  white-space: nowrap;
}

.ai-platform-page {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  color: var(--color-text);
}

.ai-platform-block {
  opacity: 0;
  transform: translateY(30px);
  transition:
    opacity 0.6s ease,
    transform 0.6s ease;
}

.ai-platform-block.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.background-card {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 36px 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
  transition: box-shadow 0.3s ease;
}

.background-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.case-content {
  max-width: 100%;
  margin: 0 auto;
  text-align: left;
}

.section-content-cases {
  text-align: left;
}

.section-content-cases .case-content,
.section-content-cases .case-section,
.section-content-cases .case-text,
.section-content-cases .case-list {
  text-align: left;
}

.case-content-blink {
  padding: 24px;
  border-radius: 8px;
  animation: case-blink 2.5s ease-in-out infinite;
}

@keyframes case-blink {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 rgba(6, 85, 159, 0); }
  50% { opacity: 0.88; box-shadow: 0 0 28px rgba(6, 85, 159, 0.25); }
}

.case-section + .case-section {
  margin-top: 32px;
}

.case-subtitle {
  font-size: 20px;
  font-weight: 600;
  color: #06559f;
  margin-bottom: 12px;
}

.case-text {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
}

.case-text-full {
  font-size: 16px;
  line-height: 1.9;
  text-align: left;
}

.case-list {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  padding-left: 0;
  list-style: none;
}

@media (max-width: 1200px) {
  .mobile-hidden-img {
    display: none;
  }
}

.hero {
  position: relative;
  height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    110deg,
    #eaf2ff 0%,
    #f7fbff 40%,
    #eef5ff 60%,
    #dfeaff 100%
  );
  overflow: hidden;
}

.hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(
      1200px 360px at 75% 20%,
      rgba(24, 144, 255, 0.18) 0%,
      rgba(24, 144, 255, 0) 60%
    ),
    radial-gradient(
      800px 300px at 20% 80%,
      rgba(64, 158, 255, 0.2) 0%,
      rgba(64, 158, 255, 0) 60%
    );
}

.hero-inner {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  padding: 0 24px;
  text-align: left;
}

.hero-inner h1 {
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 18px;
  color: #0f172a;
}

.hero-inner p {
  font-size: 16px;
  line-height: 1.7;
  color: #333;
}

.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.card {
  display: flex;
  align-items: flex-start;
  gap: 17px;
  background: #f5f7fa;
  /* border: 1px solid #E6EBF5; */
  /* box-shadow: 0px 3px 6px 0px #EBEFF7; */
  border-radius: 6px;
  padding: 30px 30px;
  min-height: 173px;
  box-sizing: border-box;
}

.card-icon {
  flex-shrink: 0;
}
.card-text {
  display: flex;
  flex-direction: column;
  text-align: start;
}
.card-title {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  color: #000000;
  line-height: 40px;
}
.card-desc {
  font-size: 14px;
  line-height: 1.7;
  color: #666;
}

.scenarios {
  display: flex;
  /* grid-template-columns: minmax(0, 1fr) 629px; */
  /* gap: 0; */
  align-items: stretch;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.scenario-text {
  background: #fff;
  border-radius: 4px;
  /* box-shadow: 0px 3px 6px 0px #EBEFF7; */
  padding: 50px 50px 0px 40px;
  /* height: 369px; */
  box-sizing: border-box;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  text-align: start;
}

.scenario-item {
  margin-bottom: 18px;
}
.scenario-item .item-title {
  font-size: 16px;
  line-height: 16px;
  color: #333;
  margin-bottom: 8px;
  font-family: PingFang SC;
}
.scenario-item .item-desc {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
}
/* .scenario-item.highlight .item-title { color: #FF6A00; } */

.scenario-image {
  background-image: url("@/assets/jiejue/ai-tiaozhan/1.jpg");
  background-size: cover;
  background-position: center;
  border-radius: 6px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 629px;
  height: 369px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.scenario-image::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 40%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.85) 40%,
    rgba(255, 255, 255, 0) 100%
  );
  pointer-events: none;
}

.diagram {
  display: grid;
  gap: 12px;
}
.layer {
  background: #fff;
  border: 1px solid #e6ebf5;
  border-radius: 6px;
}
.layer-title {
  padding: 10px 14px;
  font-size: 14px;
  color: #333;
  background: #f6f9ff;
  border-color: #dfe8ff;
}
.layer-title.blue {
  background: #e8f2ff;
  border-color: #cfe0ff;
}
.grid.layer-app {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 12px;
}
.grid.layer-ml {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  padding: 12px;
}
.grid.layer-data {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  padding: 12px;
}
.grid.layer-infra {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  padding: 12px;
}
.grid.layer-app > div,
.grid.layer-ml > div,
.grid.layer-data > div,
.grid.layer-infra > div {
  background: #f9fbff;
  border: 1px dashed #e1e9ff;
  border-radius: 6px;
  padding: 12px;
  text-align: center;
  font-size: 13px;
}

@media (max-width: 1200px) {
  .grid-2 {
    grid-template-columns: 1fr;
  }
  .grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
  .section-row {
    flex-direction: column;
    gap: 24px;
    padding: 40px 0;
  }
  .section-title {
    width: 100%;
    font-size: 22px;
  }
}

@media (max-width: 768px) {
  .solution-body {
    padding: 0 16px 40px;
  }
  .section-row {
    padding: 30px 0;
    gap: 16px;
  }
  .section-title {
    font-size: 20px;
  }
  .grid-2 {
    grid-template-columns: 1fr;
  }
  .grid-4 {
    grid-template-columns: 1fr;
  }
  .grid.layer-ml,
  .grid.layer-data,
  .grid.layer-infra {
    grid-template-columns: repeat(2, 1fr);
  }
  .scenario-image {
    width: 100%;
    height: 280px;
  }
  .scenario-text {
    height: auto;
    border-radius: 6px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
#advantages {
  background: linear-gradient(180deg, #f5f7fa 0%, #e0ecff 100%);
  max-width: unset;
  padding: 60px 20px 90px 20px;
}
.advantages .grid-4 {
  align-items: stretch;
  gap: 20px;
  max-width: 1416px;
  margin: 0 auto;
}
.adv-card {
  min-height: 240px;
  position: relative;
  background: #fff;
  border-radius: 4px;
  padding: 29px;
  padding-top: 70px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  text-align: start;
}
.adv-badge {
  position: absolute;
  top: 33px;
  left: 29px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: #1890ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
}
.adv-title {
  font-size: 16px;
  font-family: PingFang SC;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
}
.adv-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}
.main-content {
  background: #fff;
}
#scenarios {
  max-width: unset;
  background: #f5f7fa;
  padding: 60px 20px 90px 20px;
}

@media (max-width: 576px) {
  .tabs {
    gap: 20px;
  }
}
</style>
